import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { roundsWinBetTypes } from '../../store/roundsWinBetTypes';
import { BET_TYPES_LETTERS, OWNER_CLASS } from '../../enums/cardOwner';

export const LastResults = observer(() => {
  const { winBetTypes } = roundsWinBetTypes;
  const t = useTranslation();
  return (
    <div className='none-stop-result-holder'>
      {/* add and remove class "ball-change" */}
      {winBetTypes.length
        ? // ? lastResults.reverse().map(({ roundId, roundData }) => (
          winBetTypes.map(({ roundId, roundData }) => (
            <div
              key={roundId}
              className={`none-stop-result-ball ${OWNER_CLASS[roundData.winType]}`}
            >
              <span className='none-stop-result-ball-text'>
                {t(BET_TYPES_LETTERS[roundData.winType])}
              </span>
            </div>
          ))
        : null}
    </div>
  );
});
